(function () {
    'use strict';

    angular.module('app').controller('PriceGroupsController', PriceGroupsController);

    PriceGroupsController.$inject = [
        '$rootScope', '$scope', '$filter', '$routeParams', '$location', '$timeout', '$translate', '$anchorScroll',
        'blockUI', '$uibModal', 'NotifyService',
        'LoyaltyService', 'PriceGroupsService', 'SelectService', 'SettingsService', 'GoodsService', 'BusinessService',
        'LANGS'];

    function PriceGroupsController($rootScope, $scope, $filter, $routeParams, $location, $timeout, $translate, $anchorScroll,
                                   blockUI, $uibModal, NotifyService,
                                   LoyaltyService, PriceGroupsService, SelectService, SettingsService, GoodsService, BusinessService,
                                   LANGS) {
        $scope.getTimezonesList = SelectService.getTimezonesList;
        $scope.getCurrenciesList = getCurrenciesList;
        $scope.refreshMatrixAxes = refreshMatrixAxes;
        $scope.getGoodsCategoriesList = SelectService.getGoodsCategoriesList;
        $scope.getLoyaltiesList = SelectService.getLoyaltiesList;
        $scope.currentTab = 'general';

        $scope.errors = {};
        $scope.data = {
            default_item_price_decimal_digits: 2,
            maximum_item_price_decimal_digits: 2,
            taxes: [],
            loyaltiesList: [], // список лояльностей
            filterPriceGroups: {
                loyaltyID: false

            },
            filterMatrixPrices: {
                calculating_datetime: moment().utc().toDate()
            },
            loyaltyID: false,
            pagerLengths: [10, 20, 50, 100, 200]
        };

        $scope.paramsItems = {
            page: 1,
            count: 20,
            include_master_price: true,
            include_tax_rates: true,
            include_prices: true,
            item_category_id: 'all',
            exclude_without_price: true
        };

        // $scope.isRouteMode = isRouteMode;
        $scope.isPageMode = isPageMode;
        $scope.getPages = getTotalPaginatedPages;

        $scope.matrixAxes = [];

        $scope.priceGroups = [];
        $scope.priceGroup = {};
        $scope.priceGroupTaxes = [];
        $scope.priceGroupItems = [];

        $scope.priceGroupID = $routeParams.priceGroupID;
        $scope.currentMode = getPageMode();

        var block_price_groups_list = blockUI.instances.get('price_groups_list'),
            block_edit_price_group_form = blockUI.instances.get('edit_price_group_form'),
            block_matrix_axes = blockUI.instances.get('matrix_axes'),
            block_edit_price_groups_list = blockUI.instances.get('edit_price_groups_list');

        initController();

        function initController() {
            SettingsService.GetPlatformParams(function (success, response) {
                if (success) {
                    if (typeof response.default_item_price_decimal_digits === 'number') {
                        $scope.data.default_item_price_decimal_digits = response.default_item_price_decimal_digits;
                    }
                    if (typeof response.maximum_item_price_decimal_digits === 'number') {
                        $scope.data.maximum_item_price_decimal_digits = response.maximum_item_price_decimal_digits;
                    }
                }
            });
            switch ($scope.currentMode) {
                case 'matrix-axes':

                    break;
                case 'price-groups':

                    break;
                case 'add-price-group':
                    $scope.data.currentLoyaltyID = $routeParams.loyaltyID;
                    block_edit_price_groups_list.start();
                    $scope.priceGroup.price_decimal_digits = $scope.data.default_item_price_decimal_digits;
                    if ('Intl' in window) {
                        if (!$scope.data.timezonesList) {
                            $scope.getTimezonesList(function () {
                                try {
                                    $scope.priceGroup.default_time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                                } catch (e) {

                                }
                            });
                        } else {
                            try {
                                $scope.priceGroup.default_time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                            } catch (e) {

                            }
                        }

                    }
                    $scope.data.taxes = [];
                    LoyaltyService.GetTaxes($routeParams.loyaltyID, function (success, data) {
                        $scope.data.taxes = data;
                    });
                    block_edit_price_groups_list.stop();
                    break;
                case 'edit-price-group':
                    block_edit_price_groups_list.start();
                    if ($routeParams['tab'] && $routeParams['tab'] !== 'general') {
                        $scope.currentTab = $routeParams['tab'];
                    }

                    SelectService.getGoodsCategoriesList($routeParams.loyaltyID, function (success, response) {
                        $scope.data.categoriesList = angular.copy(response);
                        $scope.data.categoriesList.unshift({
                            id: 'root',
                            active: 1,
                            title: $filter('translate')('Without category')
                        });
                        $scope.data.categoriesList.unshift({
                            id: 'all',
                            active: 1,
                            title: $filter('translate')('All category')
                        });

                    });

                    $scope.priceGroup = {};
                    $scope.data.taxes = [];

                    PriceGroupsService.GetPriceGroup($routeParams.loyaltyID, $scope.priceGroupID, function (success, data) {
                        if (success) {
                            $scope.priceGroup = data;
                        }
                        PriceGroupsService.GetPriceGroupTaxes($routeParams.loyaltyID, $scope.priceGroupID, function (success, data) {
                            if (success) {
                                $scope.priceGroupTaxes = data;
                            }

                            LoyaltyService.GetTaxes($routeParams.loyaltyID, function (success, data) {
                                data.forEach(function (tax) {
                                    var priceGroup = $scope.priceGroupTaxes.find(function (el) {
                                        return el.tax_id === tax.id;
                                    });
                                    if (priceGroup) {
                                        tax.use_base_tax_value = priceGroup.use_base_tax_value;
                                    } else {
                                        tax.use_base_tax_value = 'none';
                                    }
                                });
                                $scope.data.taxes = data;

                                refreshPriceGroupItems(function () {
                                    block_edit_price_groups_list.stop();
                                });
                            });

                        });
                    });

                    break;

            }
            var unbindTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
                SettingsService.Timezones(function (success, data) {
                    ($scope.priceGroupItems.data || []).forEach(function (item) {
                        item.master_price.time_zone_show = timeZonesToTitle(item.master_price.time_zone);
                        return item;

                    });
                });

            });
            $scope.$on('$destroy', unbindTranslateChangeSuccess);
        }

        $scope.priceGroupTaxChange = function (tax) {
            var indexTax = $scope.priceGroupTaxes.findIndex(function (t) {
                return t.tax_id === tax.id;
            });
            if (indexTax !== -1) {
                $scope.priceGroupTaxes.splice(indexTax, 1);
                tax.use_base_tax_value = 'none';
            } else {
                tax.use_base_tax_value = 1;
                $scope.priceGroupTaxes.push({
                    tax_id: tax.id,
                    default_value: tax.default_value,
                    use_base_tax_value: tax.use_base_tax_value,
                    tax_classification: tax.classification
                });
            }
        };
        $scope.checkUseBaseTaxValue = function (tax) {
            var indexTax = $scope.priceGroupTaxes.findIndex(function (t) {
                return t.tax_id === tax.id;
            });

            if (indexTax === -1) {
                $scope.priceGroupTaxes.push({
                    tax_id: tax.id,
                    default_value: tax.default_value,
                    use_base_tax_value: tax.use_base_tax_value
                });
            } else {
                $scope.priceGroupTaxes[indexTax].use_base_tax_value = tax.use_base_tax_value;
                if (tax.use_base_tax_value == 1) {
                    $scope.priceGroupTaxes[indexTax].default_value = tax.default_value;
                }
            }
        };

        $scope.onCountChangePriceGroupItems = function (count) {
            block_edit_price_groups_list.start();
            $scope.paramsItems.page = 1;
            $scope.paramsItems.count = count;
            refreshPriceGroupItems(function () {
                block_edit_price_groups_list.stop();
            });
        };

        $scope.pageChangePriceGroupItems = function () {
            block_edit_price_groups_list.start();
            refreshPriceGroupItems(function () {
                block_edit_price_groups_list.stop();
            });
        };

        /*$scope.timeZonesToTitle = */
        function timeZonesToTitle(timezone_title) {
            if ($rootScope.TIMEZONES[$rootScope.LANG] && timezone_title) {

                var timezone_title_lang = $rootScope.TIMEZONES[$rootScope.LANG].find(function (timezone) {
                    return timezone.id === timezone_title;
                });
                if (timezone_title_lang) {
                    return timezone_title_lang.title;
                }
            }

            return timezone_title;
        }

        $scope.onChangeShowOnlyActive = function (event) {
            block_edit_price_groups_list.start();
            refreshPriceGroupItems(function () {
                block_edit_price_groups_list.stop();
            });

        };

        function refreshPriceGroupItems(callback) {

            var paramsItems = angular.copy($scope.paramsItems);
            if (paramsItems.item_category_id && paramsItems.item_category_id === 'all') {
                delete paramsItems.item_category_id;
            }

            PriceGroupsService.GetPriceGroupItems($routeParams.loyaltyID, $scope.priceGroupID, paramsItems, function (success, data) {
                if (success) {
                    data.data.map(function (item) {
                        item.master_price.time_zone_show = timeZonesToTitle(item.master_price.time_zone);
                        return item;
                    });

                    $scope.priceGroupItems = data;
                }
                if (callback) {
                    callback();
                }
            });
        }

        function refreshPriceGroups(loyaltyID) {
            block_price_groups_list.start();
            $scope.priceGroups = [];

            PriceGroupsService.GetPriceGroups(loyaltyID || $scope.data.filterPriceGroups.loyaltyID, {}, function (success, data) {
                if (success) {

                    data.map(function (item) {
                        item.default_time_zone = timeZonesToTitle(item.default_time_zone);
                        return item;
                    });

                    $scope.priceGroups = data;

                }
                block_price_groups_list.stop();
            });
        }

        $scope.refreshMatrixAxesWithCurrentDate = function () {
            $scope.data.filterMatrixPrices.calculating_datetime = moment().utc().toDate();
            refreshMatrixAxes();
        };

        function refreshMatrixAxes(loyaltyID) {
            block_matrix_axes.start();
            $scope.matrixAxes = [];
            PriceGroupsService.GetMatrixAxes(loyaltyID || $scope.data.filterPriceGroups.loyaltyID, function (success, matrixAxes) {
                if (success) {
                    // $scope.matrixAxes = data;

                    var params = dateFieldsFormat({
                        calculating_datetime: $scope.data.filterMatrixPrices.calculating_datetime
                    }, null, 'YYYY-MM-DD[T]HH:mm:ss[Z]', false);

                    PriceGroupsService.GetMatrixPrices(loyaltyID || $scope.data.filterPriceGroups.loyaltyID, params,
                        function (success, matrixMasterPrices) {
                            matrixAxes.matrix = [];
                            matrixAxes.price_groups.forEach(function (price_group) {
                                var row = {
                                    rowItems: [],
                                    price_group_id: price_group.price_group_id,
                                    loyalty_id: price_group.loyalty_id
                                };

                                var valuesMasterPrice = matrixMasterPrices.find(function (matrixMasterPrice) {
                                    return matrixMasterPrice.price_group_id === price_group.id;
                                });

                                matrixAxes.items.forEach(function (item) {
                                    var value_item = valuesMasterPrice.items.find(function (valueMasterPrice) {
                                        return valueMasterPrice.item_id === item.item_id;
                                    });
                                    if (value_item) {
                                        row.rowItems.push(Object.assign(value_item, {
                                            master_price: {
                                                value: value_item.prices.master_price_value,
                                                currency: value_item.prices.currency
                                            },
                                            state: {}
                                        }));
                                    } else {
                                        row.rowItems.push({
                                            item_id: item.item_id,
                                            price_group_id: price_group.id,
                                            state: {}
                                        });
                                    }

                                });
                                matrixAxes.matrix.push(row);
                            });
                            matrixAxes.master_prices = matrixMasterPrices;
                            $scope.matrixAxes = matrixAxes;
                            block_matrix_axes.stop();
                        });
                }

            });
        }

        $scope.onChangeTab = function (tab) {

            console.info('TAB', tab);

            var form = angular.element('#form').scope().form;
            console.info('FORM', form);

            if ($scope.currentTab === 'general' && tab !== 'general' && (form.$dirty || isPageMode('add-price-group'))) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    keyboard: true,
                    size: 'sm',
                    templateUrl: 'app/templates/modal.confirmation.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this;

                        popup.type = 'price-groups';

                        popup.onSaveClick = function (exit) {
                            if (form.$valid && form.$dirty) {
                                $scope.savePriceGroup(form, false, true);
                                $scope.currentTab = tab;
                                $location.url($location.$$path + '?tab=' + tab);
                                // onSwitchTab(tab);
                            } else {
                                form.$dirty = true;
                                form.title.$dirty = form.currency.$dirty = form.decimal_digits.$dirty = form.timezone.$dirty = true;
                            }
                            $uibModalInstance.close();
                        };

                        popup.onCancelClick = function (exit) {
                            if (isPageMode('add-price-group'))
                                $scope.currentTab = 'general';
                            else {
                                $scope.currentTab = tab;
                                $location.url($location.$$path + '?tab=' + tab);
                                //    onSwitchTab(tab);
                            }
                            $uibModalInstance.close();
                        };
                    }
                });
                return;
            }

            $scope.currentTab = tab;
            $location.url($location.$$path + '?tab=' + tab);
        };

        /**
         *
         * @param {'add-price-group' | 'price-groups' | 'edit-price-group' | 'matrix-axes'} mode
         * @returns {boolean}
         */
        function isPageMode(mode) {
            return mode === $scope.currentMode;
        }

        /**
         *
         * @returns {'add-price-group' | 'price-groups' | 'edit-price-group' | 'matrix-axes'}
         */
        function getPageMode() {
            if ($routeParams.loyaltyID === 'matrix-axes') {
                return 'matrix-axes';
            }

            if ($routeParams.loyaltyID && $scope.priceGroupID && $routeParams.pageMode === 'edit') {
                return 'edit-price-group';
            }
            if ($routeParams.loyaltyID && $routeParams.pageMode === 'add') {
                return 'add-price-group';
            }
            return 'price-groups';
        }

        function getCurrenciesList() {
            if (!$scope.data.currenciesList || $scope.data.currenciesList.length === 0)
                BusinessService.CurrencyList(null, function (success, response) {
                    if (success) {
                        $scope.data.currenciesList = response;

                        if ($scope.data.currenciesList.indexOf('EUR') === -1)
                            $scope.data.currenciesList.push('EUR');

                        if ($scope.data.currenciesList.indexOf('USD') === -1)
                            $scope.data.currenciesList.push('USD');
                    }
                });
        }

        $scope.savePriceGroup = function (form, needClose, isTabSwitch) {
            var priceGroup = angular.copy($scope.priceGroup),
                priceGroupTaxes = angular.copy($scope.priceGroupTaxes);
            if (form.$valid) {
                block_edit_price_group_form.start();
                var callbackResult = function (success, data) {
                    if (success) {
                        var PriceGroupTaxes = [];
                        priceGroupTaxes.forEach(function (t) {
                            PriceGroupTaxes.push({
                                tax_id: t.tax_id,
                                default_value: parseFloat(t.default_value),
                                use_base_tax_value: parseInt(t.use_base_tax_value)
                            });
                        });
                        PriceGroupsService.UpdatePriceGroupTaxes($routeParams.loyaltyID, data.id, PriceGroupTaxes, function (success, data) {
                            if (success) {
                                $scope.priceGroupTaxes = data;
                                NotifyService.Success('', false);
                            }

                            if (needClose) {
                                $location.path('/price-groups');
                            }

                            form.$dirty = form.title.$dirty = form.currency.$dirty = form.decimal_digits.$dirty = form.timezone.$dirty = false;

                            if (isPageMode('add-price-group') && isTabSwitch) {
                                $location.path('/price-groups/' + data.loyalty_id + '/edit/' + data.id);
                            }

                            block_edit_price_group_form.stop();
                        });

                    } else {
                        block_edit_price_group_form.stop();
                    }

                };

                if (isPageMode('add-price-group')) {
                    PriceGroupsService.AddPriceGroup(
                        $routeParams.loyaltyID,
                        priceGroup,
                        callbackResult);
                } else {

                    if ($scope.priceGroup.base_price_is_sale_price) {
                        var PriceGroupTaxes = [];
                        priceGroupTaxes.forEach(function (t) {
                            PriceGroupTaxes.push({
                                tax_id: t.tax_id,
                                default_value: parseFloat(t.default_value),
                                use_base_tax_value: parseInt(t.use_base_tax_value)
                            });
                        });
                        PriceGroupsService.UpdatePriceGroupTaxes($routeParams.loyaltyID, $routeParams.priceGroupID, PriceGroupTaxes, function (success, data) {
                            if(!success) {
                                NotifyService.Error('', false);
                                return
                            }
                            if (success) {
                                $scope.priceGroupTaxes = data;
                                PriceGroupsService.UpdatePriceGroup(
                                    $routeParams.loyaltyID,
                                    $routeParams.priceGroupID,
                                    priceGroup,
                                    function (successUpdate, dataUpdate) {
                                        if (successUpdate) {
                                            NotifyService.Success('', false);
                                        }

                                        if (needClose) {
                                            $location.path('/price-groups');
                                        }

                                        if (isPageMode('add-price-group') && isTabSwitch) {
                                            $location.path('/price-groups/' + data.loyalty_id + '/edit/' + data.id);
                                        }

                                        block_edit_price_group_form.stop();
                                    });
                            }

                            block_edit_price_group_form.stop();
                        });
                    } else {
                        PriceGroupsService.UpdatePriceGroup(
                            $routeParams.loyaltyID,
                            $routeParams.priceGroupID,
                            priceGroup,
                            callbackResult);
                    }


                }

            } else {
                if (form.title.$invalid) {
                    form.title.$dirty = true;
                }
                if (form.currency.$invalid) {
                    form.currency.$dirty = true;
                }
                if (form.decimal_digits.$invalid) {
                    form.decimal_digits.$dirty = true;
                }
                if (form.timezone.$invalid) {
                    form.timezone.$dirty = true;
                }
            }
        };

        $scope.onCancelEditPriceGroup = function () {
            $location.path('/price-groups');
        };

        $scope.deletePriceGroup = function (priceGroup) {
            PriceGroupsService.DeletePriceGroup(priceGroup.loyalty_id, priceGroup.id, function () {
                refreshPriceGroups();
            });
        };

        $scope.deletePriceGroupItem = function (priceGroupItem) {
            var LOYALTY_ID = $routeParams.loyaltyID,
                PRICE_GROUP_ID = $routeParams.priceGroupID;
            block_edit_price_groups_list.start();
            PriceGroupsService.DeletePriceGroupsItem(LOYALTY_ID, PRICE_GROUP_ID, priceGroupItem.item_id, function () {
                refreshPriceGroupItems(function () {
                    block_edit_price_groups_list.stop();
                });
            });
        };
        $scope.saveRowMatrix = function (indexRow, SuccessMessage, saveWithCurrentDate) {
            var row = $scope.matrixAxes.matrix[indexRow];
            var rowItems = angular.copy(row.rowItems).filter(function (td) {
                return !!td.master_price;
            }).map(function (td) {
                delete td.state;
                return td;
            });
            var countSave = rowItems.length;
            var localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            rowItems.forEach(function (item) {
                if (saveWithCurrentDate) {
                    item.master_price.starting = null;
                    item.master_price.time_zone = localTimeZone;
                }
                PriceGroupsService.UpdatePriceGroupsItem(item.loyalty_id, item.price_group_id, item.item_id, item, function (success, data) {
                    if (!--countSave) {
                        if (SuccessMessage) {
                            NotifyService.Success(SuccessMessage, false);
                        } else {
                            NotifyService.Success($filter('translate')('PRICE_GROUPS_MATRIX_AXES_PRICE_SAVE_SUCCESS'), false);
                        }
                        $scope.matrixAxes.matrix[indexRow].isFocus = false;
                    }
                });
            });
        };
        $scope.openModalDelaySet = function (indexRow) {
            // modal.delay-set.html
            $uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/pages/price-groups/modals/modal.delay-set.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-center',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.loading = true;
                    popup.starting_opened = false;
                    popup.master_price_starting = null;
                    popup.master_price_time_zone = $scope.matrixAxes.price_groups[indexRow].default_time_zone;
                    popup.timezonesList = [];
                    SettingsService.Timezones(function (success, data) {
                        popup.timezonesList = data;
                        popup.loading = false;
                    });
                    popup.delaySet = function () {
                        popup.master_price_starting = moment(popup.master_price_starting).utcOffset(0, true).format()
                        $scope.matrixAxes.matrix[indexRow].rowItems.map(function (td) {
                            if (td.master_price) {
                                td.master_price.starting = popup.master_price_starting;
                                td.master_price.time_zone = popup.master_price_time_zone;
                            }
                            return td;
                        });
                        $scope.saveRowMatrix(indexRow,
                            $filter('translate')('PRICE_GROUPS_MATRIX_AXES_DELAY_SET_SUCCESS', {
                                date_string: '\n' + $filter('date')(popup.master_price_starting, 'medium', 'UTC') + ' ' +
                                    $filter('date')(popup.master_price_starting, 'HH:mm:ss', 'UTC')
                                    + ' ' + popup.master_price_time_zone
                            }, false)
                        );
                        $uibModalInstance.close();
                    };
                    popup.closeModal = function (exit) {
                        $uibModalInstance.close();
                    };
                }
            });
        };
        $scope.openModalHistoryPriceGroupItem = function (priceGroupItem) {
            var LOYALTY_ID = $routeParams.loyaltyID,
                PRICE_GROUP_ID = $routeParams.priceGroupID;
            $uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/pages/price-groups/modals/modal.price-group-item.history.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-center',
                size: 'lg',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.MasterPricesHistory = [];
                    popup.loading = true;
                    console.log('priceGroupItem', priceGroupItem);

                    function refreshHistory() {
                        PriceGroupsService.GetMasterPricesHistory(LOYALTY_ID, PRICE_GROUP_ID, priceGroupItem.item_id,
                            function (success, data) {
                                popup.MasterPricesHistory = data;
                                data.map(function (item) {
                                    item.time_zone = timeZonesToTitle(item.time_zone);
                                    return item;
                                });

                                popup.loading = false;
                                tableUI.stop();
                            });
                    }

                    PriceGroupsService.GetMasterPricesHistory(LOYALTY_ID, PRICE_GROUP_ID, priceGroupItem.item_id, function (success, data) {
                        data.map(function (item) {
                            item.time_zone = timeZonesToTitle(item.time_zone);
                            return item;
                        });

                        popup.MasterPricesHistory = data;

                        popup.loading = false;
                    });

                    var tableUI = blockUI.instances.get('table-history');
                    popup.delete = function (item) {
                        PriceGroupsService.DeleteMasterPricesHistory(LOYALTY_ID, PRICE_GROUP_ID, priceGroupItem.item_id, item.id,
                            function (success, data) {
                                tableUI.start();
                                refreshHistory();
                            });

                    };

                    popup.closeModal = function (exit) {
                        $uibModalInstance.close();
                    };
                }
            });
        };

        $scope.openModalPriceGroupItem = function (priceGroupItem) {
            var LOYALTY_ID = $routeParams.loyaltyID,
                PRICE_GROUP_ID = $routeParams.priceGroupID;

            $uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/pages/price-groups/modals/modal.price-group-item.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-center',
                controller: function ($uibModalInstance) {

                    var popup = this;

                    popup.taxRatesOptions = [
                        {
                            title: 'Default',
                            value: 'default'
                        },
                        {
                            title: 'Not use',
                            value: 'not-use'
                        },
                        {
                            title: 'Manual',
                            value: 'manual'
                        }
                    ];

                    popup.masterPriceColor = '';
                    popup.masterPriceStartingColor = '';
                    popup.excludeFromPriceGroup = false;
                    popup.loading = true;
                    popup.goods_items = [];
                    popup.starting_opened = false;
                    popup.priceGroupItem = priceGroupItem ? angular.copy(priceGroupItem) : {
                        item_id: null,
                        tax_rates: [],
                        master_price: {
                            time_zone: $scope.priceGroup.default_time_zone || '',
                        }
                    };
                    popup.starting_opened = false;
                    popup.taxes = [];

                    popup.last_price_date = null;
                    popup.last_price_time_zone = null;

                    if (
                        popup.priceGroupItem &&
                        popup.priceGroupItem.master_price &&
                        popup.priceGroupItem.master_price.starting &&
                        popup.priceGroupItem.master_price.time_zone
                    ) {
                        popup.last_price_date =
                            popup.priceGroupItem.master_price.starting;
                        popup.last_price_time_zone =
                            popup.priceGroupItem.master_price.time_zone;
                        popup.priceGroupItem.master_price.starting = null;
                    }

                    if (!priceGroupItem) {
                        PriceGroupsService.GetPriceGroupTaxes(LOYALTY_ID, PRICE_GROUP_ID, function (success, data) {
                            popup.taxes = data;
                            setFieldsMode();
                            popup.loading = false;
                        });
                        PriceGroupsService.GetGoodsSelect(LOYALTY_ID, PRICE_GROUP_ID, {
                            existence_type: 'not-in-group'
                        }, function (success, data) {
                            popup.goods_items = data;
                            if (data.length === 0) {
                                NotifyService.Error($filter('translate')('PRICE_GROUPS_NO_PRODUCTS_AVAILABLE'), false);
                                popup.closeModal();
                            }
                        });
                    } else {
                        popup.taxes = angular.copy(priceGroupItem.tax_rates);
                        popup.loading = false;
                        setFieldsMode();
                    }

                    function setFieldsMode() {
                        popup.taxes.forEach(function (tax) {

                            if(tax.tax_not_used == 1) {
                                tax.fieldMode = 'not-use';
                            }

                            if(tax.tax_not_used == 0) {
                                if (tax.value === null) {
                                    tax.fieldMode = 'default';
                                    tax.value = tax.default_value;
                                } else {
                                    tax.fieldMode = 'manual';
                                }
                            }

                        });
                    }

                    SettingsService.Timezones(function (success, data) {
                        popup.timezonesList = data;
                    });

                    popup.corruptedFields = [];
                    popup.additionalCostValidator = {
                        isItemValid: function (formData) {
                            var form = formData || popup.priceGroupItem;
                            return !!form && !!form.item_id;
                        }
                    };

                    function validatePriceGroupItem() {
                        var validationResult = {
                            isValid: true,
                            corruptedFields: []
                        };

                        for (var validatorName in popup.additionalCostValidator) {
                            var isValid = popup.additionalCostValidator[validatorName](popup.additional_cost);
                            if (!isValid) {
                                validationResult.corruptedFields.push(validatorName);
                                validationResult.isValid = false;
                            }
                        }

                        return validationResult;
                    }

                    popup.taxRateFieldModeChange = function (taxRate) {
                        switch (taxRate.fieldMode) {
                            case 'manual':
                            case 'default':
                                taxRate.tax_not_used = 0;
                                taxRate.value = taxRate.default_value;
                                break;
                            case 'not-use':
                                taxRate.tax_not_used = 1;
                                taxRate.value = 0;
                                break;
                            default:
                                break;
                        }
                    };

                    popup.onExcludeFromPriceGroup = function () {
                        if (popup.excludeFromPriceGroup) {
                            angular.element('input[id="master_price_value"]')[0].value = '';
                        }
                    };
                    popup.addPriceGroupItem = function (form) {

                        var validationResult = validatePriceGroupItem();
                        popup.corruptedFields = validationResult.corruptedFields;
                        if (!validationResult.isValid) {
                            return;
                        }
                        var priceGroupItem = angular.copy(popup.priceGroupItem);
                        priceGroupItem.master_price.value = popup.excludeFromPriceGroup
                            ? priceGroupItem.master_price.value = null
                            : parseFloat(
                                priceGroupItem.master_price.value);
                        priceGroupItem.tax_rates = popup.taxes.map(function (tax) {
                            var tax_rate = {
                                tax_id: tax.tax_id
                            };
                            if (tax.value !== undefined) {
                                tax_rate.value = parseFloat(tax.value);
                            }

                            return tax_rate;
                        });

                        if (!popup.priceGroupItem.master_price.starting) {
                            NotifyService.Error($filter('translate')('Starting date is required'), false);
                            popup.masterPriceStartingColor = '#e73d4a';
                            return false;
                        } else {
                            popup.masterPriceStartingColor = '';
                        }

                        priceGroupItem.master_price.starting = moment(priceGroupItem.master_price.starting).utcOffset(0, true).format();

                        if ((!priceGroupItem.master_price.value || priceGroupItem.master_price.value <= 0) && !popup.excludeFromPriceGroup) {
                            NotifyService.Error($filter('translate')('Master price value is required'), false);
                            popup.masterPriceColor = '#e73d4a';
                            return false;
                        } else {
                            block_edit_price_groups_list.start();
                            popup.masterPriceColor = '';
                            PriceGroupsService.AddPriceGroupsItem(LOYALTY_ID, PRICE_GROUP_ID, [priceGroupItem], function (success, data) {
                                refreshPriceGroupItems(function () {
                                    popup.closeModal();
                                    block_edit_price_groups_list.stop();
                                });
                            });
                        }
                    };

                    popup.updatePriceGroupItem = function () {

                        var priceGroupItem = angular.copy(popup.priceGroupItem);
                        priceGroupItem.master_price.value = popup.excludeFromPriceGroup
                            ? priceGroupItem.master_price.value = null
                            : parseFloat(
                                priceGroupItem.master_price.value);
                        priceGroupItem.tax_rates = angular.copy(popup.taxes).map(function (tax) {
                            var tax_rate = {
                                tax_id: tax.tax_id
                            };

                            tax_rate.tax_not_used = tax.tax_not_used;
                            tax_rate.value = tax.value;

                            switch (tax.fieldMode) {
                                case 'default':
                                    tax_rate.value = null;
                                    break;
                                case 'not-use':
                                    tax_rate.value = 0;
                                    break;
                                case 'manual':
                                    if (tax.value === null) {
                                        tax_rate.value = 0;
                                    } else {
                                        tax_rate.value = tax.value;
                                    }
                                    break;
                                default:
                                    break;
                            }

                            return tax_rate;
                        });

                        if (priceGroupItem.master_price.starting) {
                            priceGroupItem.master_price.starting = moment(priceGroupItem.master_price.starting).utcOffset(0, true).format();
                        } else {
                            priceGroupItem.master_price.starting = null;
                        }

                        if (isNaN(priceGroupItem.master_price.value) && !popup.excludeFromPriceGroup) {
                            NotifyService.Error($filter('translate')('Master price value is required'), false);
                            popup.masterPriceColor = '#e73d4a';
                            return false;
                        } else {
                            block_edit_price_groups_list.start();
                            popup.masterPriceColor = '';
                            PriceGroupsService.UpdatePriceGroupsItem(LOYALTY_ID, PRICE_GROUP_ID, priceGroupItem.item_id, priceGroupItem,
                                function (success, data) {
                                    refreshPriceGroupItems(function () {
                                        popup.closeModal();
                                        block_edit_price_groups_list.stop();
                                    });
                                });
                        }
                    };
                    popup.savePriceGroupItem = function () {

                        var priceGroupItem = angular.copy(popup.priceGroupItem);
                        priceGroupItem.master_price.value = parseFloat(priceGroupItem.master_price.value);
                        PriceGroupsService.AddPriceGroupsItem(LOYALTY_ID, PRICE_GROUP_ID, priceGroupItem.item_id, [priceGroupItem],
                            function (success, data) {
                                refreshPriceGroupItems(function () {
                                    popup.closeModal();
                                });
                            });

                    };
                    popup.closeModal = function (exit) {
                        $uibModalInstance.close();
                    };

                }
            });
        };

        $scope.basePriceIsSalePriceChange = function () {
            if ($scope.priceGroup.base_price_is_sale_price) {
                var taxes = [];
                $scope.priceGroupTaxes.forEach(function (tax) {
                    if (tax.tax_classification !== 'base-tax') {
                        taxes.push(tax)
                    }
                })
                $scope.priceGroupTaxes = taxes
            }
        }


        $rootScope.$watchCollection('[COUNTRIES[LANG],TIMEZONES[LANG]]', function (newCollection, oldCollection, scope) {
            if (newCollection[0]) {
                $scope.data.countriesList = angular.copy($rootScope.COUNTRIES[$rootScope.LANG]);
            }
            if (newCollection[1]) {
                $scope.data.timezonesList = angular.copy($rootScope.TIMEZONES[$rootScope.LANG]);
            }
        }, true);

        $rootScope.$watch('LOYALTIES', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                $scope.data.loyaltiesList = angular.copy($rootScope.LOYALTIES);

                if ($rootScope.ENV.filters && $rootScope.ENV.filters.PriceGroups && $rootScope.ENV.filters.PriceGroups.loyalty_id) {
                    $scope.data.filterPriceGroups.loyaltyID = $rootScope.ENV.filters.PriceGroups.loyalty_id;
                }

                if ($rootScope.ENV.filters.global_filter && $rootScope.ENV.filters.global_filter.loyalty_id !== '0') {
                    $scope.data.currentFilter = $scope.data.loyaltiesList.find(function (filterItem) {
                        if (filterItem.filter_list_type === 'loyalty') {
                            if (filterItem.loyaltyID === $rootScope.ENV.filters.global_filter.loyalty_id) {
                                return true;
                            }
                        } else if (filterItem.filter_list_type === 'pos' || filterItem.filter_list_type === 'register') {
                            if (filterItem.loyalty_id === $rootScope.ENV.filters.global_filter.loyalty_id) {
                                return true;
                            }
                        }
                    });
                }

                if (!$scope.data.filterPriceGroups.loyaltyID) {
                    $scope.data.filterPriceGroups.loyaltyID = getFirstActive($scope.data.loyaltiesList).id;
                }

            }
        });

        $scope.$watch('paramsItems.item_category_id', function (newValue, oldValue, scope) {
            if (newValue && newValue !== oldValue && $scope.currentTab === 'items') {
                block_edit_price_groups_list.start();
                refreshPriceGroupItems(function () {
                    block_edit_price_groups_list.stop();
                });
            }
        });

        $scope.$watch('data.filterPriceGroups.loyaltyID', function (newValue, oldValue, scope) {
            if (newValue) {
                if ($scope.isPageMode('price-groups')) {
                    refreshPriceGroups(newValue);
                }
                if ($scope.isPageMode('matrix-axes')) {
                    refreshMatrixAxes(newValue);
                }

                $rootScope.ENV.filters.PriceGroups = {
                    loyalty_id: newValue
                };
                $rootScope.ENV.filters.global_filter = {loyalty_id: newValue};
                $rootScope.storeENV();
            }
        });
    }
})();




